import { prop, required } from '@rxweb/reactive-form-validators';
import { Resource } from 'src/app/core/jsonapi/resource';

export class VoipHoliday extends Resource {
    public override type = 'voipHolidays';

    @prop()
    @required()
    public date!: string;

    @prop()
    public description?: string;
}